import { useEffect, useState } from 'react';
import { ContactPage, ManageAccounts, Cancel } from '@mui/icons-material';

// material-ui
import {
    Box,
    Button,
    Grid,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    TextField,
    FormControl,
    Select,
    MenuItem,
    Autocomplete,
    CircularProgress
} from '@mui/material';

import { useTheme } from '@mui/material/styles';
import { deepPurple } from '@mui/material/colors';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { gridSpacing } from 'app/constant';

import { useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { axiosInstance } from 'utils/axios';
import { toast } from 'react-toastify';
import { useCallback } from 'react';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const columns = [
    { id: 'id', label: 'Count', minWidth: 30 },
    { id: 'clientName', label: 'Client Name', minWidth: 120 },
    { id: 'bankName', label: 'Bank Name', minWidth: 120 },
    {
        id: 'username',
        label: 'User Name',
        minWidth: 120
    },
    { id: 'birthday', label: 'Birthday', minWidth: 170 },
    { id: 'accountNumber', label: 'Account Number', minWidth: 170 },
    { id: 'bankPhoneNumber', label: 'Bank Phone Number', minWidth: 170 },
    { id: 'createdDate', label: 'Created Date', minWidth: 170, type: 'date' }
];

const CustomerTransactions = () => {
    const user = useSelector(selectCurrentUser);
    const token = useSelector(selectCurrentToken);
    const theme = useTheme();

    const [customerTransactionsList, setCustomerTransactionsList] = useState([]);
    const [filterCustomerTransactionsFrom, setFilerCustomerTransactionsFrom] = useState(dayjs().subtract(1, 'days'));
    const [filterCustomerTransactionsTo, setFilerCustomerTransactionsTo] = useState(dayjs());
    const [filterCustomerTransactionsClientName, setFilterCustomerTransactionsClientName] = useState(0);
    const [filterBankName, setFilterBankName] = useState('');

    const [isLoading, setLoading] = useState(true);
    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = (e, reason) => {
        // if (!e.target.classList.contains('MuiMenuItem-root')) {
        setOpen(false);
        // }
    };

    const warningAlert = (message) => {
        toast.warning(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const successAlert = (message) => {
        toast.success(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const errorAlert = (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const [customerNameListArr, setCustomerNameListArr] = useState([]);
    //fetch customer names for autocomplete start
    const fetchCustomerNamesList = async () => {
        try {
            const res = await axiosInstance.get('/Customer/NameList', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setCustomerNameListArr(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch customer names for autocomplete end

    const [thirdPartyList, setThirdPartyList] = useState([]);
    const [thirdPartyListLoading, setThirdPartyListLoading] = useState(false);
    const fetchThirdPartyDropdownList = async () => {
        setThirdPartyListLoading(true);
        try {
            const res = await axiosInstance.get('/ThirdPartyTransactionLimit/AvailableOptions', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setThirdPartyList(res.data);
            } else {
                errorAlert('Something Went Wrong');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setThirdPartyListLoading(false);
        }
    };

    //fetch Customer Transactopns start
    const [fetchCustomerTransactionsLoading, setFetchCustomerTransactionsUrlLoading] = useState(false);
    const fetchCustomerTransactions = async () => {
        if (!filterCustomerTransactionsFrom.isValid() || !filterCustomerTransactionsTo.isValid()) {
            warningAlert('Please fill all required fields.');
            return;
        }
        let customerTransactionsUrl = `/CustomerTransactionDetails/All?dateFrom=${filterCustomerTransactionsFrom.format(
            'YYYY-MM-DD'
        )}&dateTo=${filterCustomerTransactionsTo.format('YYYY-MM-DD')}`;

        if (filterCustomerTransactionsClientName !== 0) {
            customerTransactionsUrl += `&customerID=${filterCustomerTransactionsClientName}`;
        }
        if (filterBankName !== '') {
            customerTransactionsUrl += `&bankName=${filterBankName}`;
        }

        setFetchCustomerTransactionsUrlLoading(true);
        setFilterBtnDisabled(true);
        try {
            const res = await axiosInstance.get(customerTransactionsUrl, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setCustomerTransactionsList(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setFilterBtnDisabled(false);
            setFetchCustomerTransactionsUrlLoading(false);
        }
    };

    //fetch Customer Transactopns end

    //insert Non Payment Date start
    const InsertTransactionLimit = () => {
        const [insertBtnDisabled, setInsertBtnDisabled] = useState(false); // Initialize as false
        const [loading, setLoading] = useState(false); // Add loading state
        const [thirdPartyID, setThirdPartyID] = useState(0);

        const [depositLimit, setDepositLimit] = useState(0);
        const [withdrawalLimit, setWithdrawalLimit] = useState(0);

        const submitInsertTransactionLimit = async () => {
            if (thirdPartyID === 0 || depositLimit === 0 || withdrawalLimit === 0) {
                warningAlert('Please fill all required fields.');
                return;
            }

            setLoading(true); // Set loading to true
            setInsertBtnDisabled(true); // Disable the button during submission

            try {
                const res = await axiosInstance.post(
                    '/ThirdPartyTransactionLimit',
                    {
                        thirdPartyID: parseInt(thirdPartyID),
                        depositLimit: parseFloat(depositLimit),
                        withdrawalLimit: parseFloat(withdrawalLimit)
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    handleClose(); // Close the modal on success
                    successAlert('Created Third Party Transaction Limit Success.');
                    fetchCustomerTransactions();
                } else {
                    errorAlert('Something went wrong');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false); // Reset loading state after request is completed
                setInsertBtnDisabled(false); // Re-enable the button
            }
        };

        return (
            <>
                <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', alignItems: 'center' }}>
                    <Button
                        onClick={handleOpen}
                        sx={{
                            border: 'none',
                            backgroundColor: deepPurple[500],
                            color: 'white',
                            marginBottom: '20px',
                            marginTop: '20px'
                        }}
                    >
                        Insert Transaction Limit
                    </Button>
                </Box>
                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    Insert Transaction Limit
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box id="modal-modal-description" sx={{}}>
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} sx={{ mt: 3 }} md={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span> Third Party
                                            </Typography>

                                            <Select
                                                displayEmpty
                                                value={thirdPartyID}
                                                onChange={(e) => setThirdPartyID(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value={0}>
                                                    Select Customer
                                                </MenuItem>
                                                {thirdPartyList.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span> Deposit Limit :
                                            </Typography>
                                            <TextField
                                                type="number"
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={depositLimit}
                                                onChange={(e) => setDepositLimit(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span> Withdrawal Limit :
                                            </Typography>
                                            <TextField
                                                type="number"
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={withdrawalLimit}
                                                onChange={(e) => setWithdrawalLimit(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitInsertTransactionLimit()}
                                disabled={insertBtnDisabled}
                            >
                                Insert
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };
    //insert Non Payment Date end

    //update Transaction Limit start
    const UpdateTransactionLimit = ({ limit }) => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);

        const [updateThirdPartyId, setUpdateThirdPartyId] = useState(limit.thirdPartyID);
        const [updateDepositLimit, setUpdateDepositLimit] = useState(limit.depositLimit);
        const [updateWithdrawalLimit, setUpdateWithdrawalLimit] = useState(limit.withdrawalLimit);

        const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
        const [loading, setLoading] = useState(false);

        const submitUpdateTransactionLimit = async () => {
            if (updateThirdPartyId === 0 || updateDepositLimit === 0 || updateWithdrawalLimit === 0) {
                warningAlert('Please fill all required fields.');
                return;
            }

            setUpdateBtnDisabled(true);
            setLoading(true);
            try {
                const res = await axiosInstance.put(
                    '/ThirdPartyTransactionLimit',
                    {
                        thirdPartyID: parseInt(updateThirdPartyId),
                        depositLimit: parseFloat(updateDepositLimit),
                        withdrawalLimit: parseFloat(updateWithdrawalLimit)
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    handleClose(); // Close the modal on success
                    successAlert('Update Transaction Limit success.');
                    fetchCustomerTransactions();
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpdateBtnDisabled(true);
                setLoading(false);
            }
        };

        return (
            <>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: 'transparent',
                        width: 'fit-content',
                        height: 'fit-content',
                        color: deepPurple[500]
                    }}
                >
                    <ManageAccounts />
                </Button>

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    Update Transaction Limit
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box
                                id="modal-modal-description"
                                sx={{
                                    height: '300px',
                                    overflowY: 'auto'
                                }}
                            >
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} sx={{ mt: 3 }} md={6}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span> Third Party :
                                            </Typography>

                                            <Select
                                                displayEmpty
                                                value={updateThirdPartyId}
                                                onChange={(e) => setUpdateThirdPartyId(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value={0}>
                                                    Select Customer
                                                </MenuItem>
                                                {thirdPartyList.map((item, index) => (
                                                    <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                        {item.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span> Deposit Limit :
                                            </Typography>
                                            <TextField
                                                type="number"
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={updateDepositLimit}
                                                onChange={(e) => setUpdateDepositLimit(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span> Withdrawal Limit :
                                            </Typography>
                                            <TextField
                                                type="number"
                                                id="outlined-basic"
                                                variant="outlined"
                                                value={updateWithdrawalLimit}
                                                onChange={(e) => setUpdateWithdrawalLimit(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitUpdateTransactionLimit()}
                                disabled={updateBtnDisabled}
                            >
                                Update
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };
    //update  Transaction Limit end

    // With Promise All
    useEffect(() => {
        setLoading(true); // Set loading to true before starting the fetches

        // Define an array of async functions to fetch data
        const fetchFunctions = [fetchCustomerTransactions(), fetchCustomerNamesList(), fetchThirdPartyDropdownList()];

        // Use Promise.all to wait for all fetches to complete
        Promise.all(fetchFunctions)
            .then(() => {
                setLoading(false); // Set loading to false after all fetches are done
            })
            .catch((error) => {
                // Handle any errors that occurred during fetching
                console.error('Error fetching data:', error);
                setLoading(false); // Set loading to false even if there was an error
            });
    }, []);

    //Customer Transactions table start
    function StickyHeadTable() {
        const [page, setPage] = useState(0);
        const [rowsPerPage, setRowsPerPage] = useState(100);

        const handleChangePage = (event, newPage) => {
            setPage(newPage);
        };

        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(+event.target.value);
            setPage(0);
        };

        return (
            <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '50px' }}>
                <TableContainer sx={{ maxHeight: 440 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                        {column.label}
                                    </TableCell>
                                ))}
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {customerTransactionsList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        {columns.map((column) => {
                                            let value = row[column.id];
                                            if (column.type && column.type === 'date') {
                                                if (value) {
                                                    const timeString12hr = new Date(
                                                        '1970-01-01T' + value.split('T')[1] + 'Z'
                                                    ).toLocaleTimeString('en-US', {
                                                        timeZone: 'UTC',
                                                        hour12: true,
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric'
                                                    });
                                                    value = `${value.split('T')[0]} ${timeString12hr}`;
                                                }
                                            }
                                            return (
                                                <TableCell key={column.id} align={column.align}>
                                                    {column.format && typeof value === 'number' ? column.format(value) : value}
                                                </TableCell>
                                            );
                                        })}
                                        <TableCell>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px'
                                                }}
                                            >
                                                {/* <UpdateTransactionLimit limit={row} /> */}
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={customerTransactionsList.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        );
    }
    //Customer Transaction table end

    return (
        <Grid container item xs={12}>
            {/* <InsertTransactionLimit /> */}

            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>From :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterCustomerTransactionsFrom}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilerCustomerTransactionsFrom(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>To :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterCustomerTransactionsTo}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilerCustomerTransactionsTo(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Customer :
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterCustomerTransactionsClientName}
                            onChange={(e) => setFilterCustomerTransactionsClientName(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value={0}>
                                Select Customer
                            </MenuItem>
                            {customerNameListArr.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Bank Name :
                        </Typography>
                        <input
                            style={{ width: '100%', height: '50px', borderRadius: '10px', border: '1px solid gray' }}
                            value={filterBankName}
                            onChange={(e) => setFilterBankName(e.target.value)}
                        />
                    </Box>
                </Grid>

                <Button
                    variant="contained"
                    sx={{
                        display: 'block',
                        mx: 'auto',
                        width: '150px',
                        backgroundColor: deepPurple[500],
                        marginTop: '20px',
                        marginBottom: '20px'
                    }}
                    onClick={() => fetchCustomerTransactions()}
                    disabled={filterBtnDisabled}
                >
                    Filter
                </Button>
            </Grid>

            <Box sx={{ width: '100%', minHeight: '200px' }}>
                {fetchCustomerTransactionsLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <StickyHeadTable />
                )}
            </Box>
        </Grid>
    );
};

export default CustomerTransactions;
